document.addEventListener("DOMContentLoaded", () => {
    const analysis = document.querySelector(".analysis");
    if (!analysis) return false;

    const urlParams = new URLSearchParams(window.location.search);
    const pushKey = urlParams.get("pushKey") || window.sessionStorage.getItem("pushKey");
    if (!pushKey) document.querySelector(".analysis__email").style.display = "none";

    // TODO: Create global utility function for email, zip & phone validation
    function validateRemote(payload) {
        return new Promise(function (resolve) {
            fetch("https://validation.audibene.net/validation", {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                body: JSON.stringify(payload),
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    // TODO: follow formClient for: why not to check response.status === 'success' ?
                    resolve(!(data.hasOwnProperty("errors") && (data.errors[0].code === "Undeliverable" || data.errors[0] === "Malformed")));
                })
                .catch(function () {
                    resolve(true);
                });
        });
    }

    function ValidateEmail(value) {
        const mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return value.match(mailformat);
    }

    const leadData = window.sessionLayer.cookie.get("LeadData");

    if (!leadData.EmailProvided) {
        const analysis = document.querySelectorAll(".analysis");

        analysis.forEach(function (item) {
            const button = item.querySelector(".analysis button");
            const input = item.querySelector(".analysis input");

            item.classList.add("analysis--show");

            input.addEventListener("keyup", function () {
                //item.classList.remove("analysis--fail");
                ValidateEmail(this.value) ? button.removeAttribute("disabled") : button.setAttribute("disabled", true);
            });

            button.addEventListener("click", function () {
                const email = input.value;
                const countryCode = window.sessionLayer.locale.slice(3, 5);
                const payload = {
                    fields: [
                        {
                            name: "Email",
                            validation: "email",
                            value: email,
                            options: ["melissa"],
                            extras: {
                                country_code: countryCode,
                            },
                        },
                    ],
                    gid: window.sessionLayer.session.getGid(),
                    url: window.location.href,
                    requester: "LandingPage",
                };

                (async function () {
                    cachedEmailResult = await validateRemote(payload);
                    const isValid = cachedEmailResult;
                    if (isValid) {
                        skipStep({ Email: email }, item, isValid);
                    } else {
                        item.classList.add("analysis--fail");
                        button.setAttribute("disabled", true);
                    }
                })();
            });
        });

        function skipStep(step, item) {
            window.sessionLayer.leadHandler.push(pushKey, step);
            item.classList.remove("analysis--email");
            item.classList.add("analysis--success");
            window.dataLayer.push({ event: "gtm-analysis-email-success" });
        }
    }
});
